import { CustomErrorType } from "../../constants/action-types";
import { SuccessDTO } from "../../constants/dto/success";
import { store } from "../../store";
import { createCall } from "../base";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS } from "../../constants/enum";
import { timeoutError } from "../../constants/reducer/base-reducer";
import {
  removeRateFromExchangeRates,
  setExchangeRateActionStart,
  setExchangeRateErrorMessage,
} from "../../constants/reducer/exchange-rate-reducer";

type DeleteExchangeRateProps = {
  id: number;
};
let body: SuccessDTO;
export const deleteExchangeRate = async (props: DeleteExchangeRateProps) => {
  store.dispatch(setExchangeRateActionStart(true));
  const { id } = props;

  await createCall(
    `cms/exchange-rate/${id}`,
    BASE_METHODS.DELETE,
    "application/json",
    undefined,
    undefined
  )
    .then(async (response) => {
      try {
        body = plainToClass(SuccessDTO, JSON.parse(await response.text()));
      } catch (error) {
        console.log(error);
        return;
      }
      if ((await validate(body)).length > 0) {
        store.dispatch(
          setExchangeRateErrorMessage("delete-exchange-rate-invalid-response")
        );
        return;
      }

      store.dispatch(removeRateFromExchangeRates(id));
    })
    .catch((error) => {
      const errorResponeData: CustomErrorType = error;
      if (errorResponeData) {
        let errorMessage = "";
        switch (errorResponeData.code) {
          case 3002:
            errorMessage = "delete-exchange-rate-data-not-found-error-message";
            break;
          default:
            break;
        }
        store.dispatch(setExchangeRateErrorMessage(errorMessage));
        return;
      }
      store.dispatch(setExchangeRateActionStart(false));
      store.dispatch(timeoutError());
    });
};
